export default __webpack_public_path__ + "static/media/Hedda_sur.4a983bb2.jpg";